import React, { useState, useEffect } from 'react';
import { Play, Info } from 'lucide-react';
import { fetchTrending, getImageUrl, imageSize } from '../services/tmdb';
import { Button } from './ui/button';

const Hero = ({ onSelectContent }) => {
  const [featured, setFeatured] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFeatured();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadFeatured = async () => {
    const trending = await fetchTrending('movie', 'week');
    if (trending && trending.length > 0) {
      const randomIndex = Math.floor(Math.random() * Math.min(5, trending.length));
      setFeatured(trending[randomIndex]);
    }
    setLoading(false);
  };

  if (loading || !featured) {
    return (
      <div className="relative h-[80vh] bg-gradient-to-b from-black to-gray-900 animate-pulse" />
    );
  }

  const title = featured.title || featured.name;
  const description = featured.overview;
  const backdropUrl = getImageUrl(featured.backdrop_path, imageSize.backdrop);

  return (
    <div className="relative h-[80vh] w-full overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backdropUrl})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center px-8 md:px-16 lg:px-24">
        <div className="max-w-2xl space-y-6">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white drop-shadow-lg">
            {title}
          </h1>
          
          <p className="text-base md:text-lg text-gray-200 line-clamp-3 drop-shadow-md">
            {description}
          </p>

          <div className="flex items-center gap-4">
            <Button
              onClick={() => onSelectContent(featured)}
              size="lg"
              className="bg-white text-black hover:bg-gray-200 font-semibold px-8 py-6 text-lg transition-all duration-200"
            >
              <Play className="mr-2 h-6 w-6 fill-current" />
              Play Trailer
            </Button>
            
            <Button
              onClick={() => onSelectContent(featured)}
              size="lg"
              variant="secondary"
              className="bg-gray-600/70 text-white hover:bg-gray-600 font-semibold px-8 py-6 text-lg backdrop-blur-sm transition-all duration-200"
            >
              <Info className="mr-2 h-6 w-6" />
              More Info
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;